import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'shared/hooks';

interface SupportRequestParams {
    email: string;
    question: string;
}

export function useSubmitSupportRequestMutation() {
    const { t } = useTranslation('auth', { keyPrefix: 'loginHelp.needHelp' });
    const { showSuccess, showError } = useToast();

    return useMutation({
        mutationFn: ({ email, question }: SupportRequestParams) =>
            new Promise<void>((resolve, reject) => {
                // eslint-disable-next-line no-underscore-dangle
                if (!window.__diagnostics) {
                    reject(new Error('unknown'));

                    return;
                }

                // eslint-disable-next-line no-underscore-dangle
                window.__diagnostics.reportSupportRequest({
                    email,
                    question,
                    onSuccess: resolve,
                    onError: (errorCode) => reject(new Error(errorCode))
                });
            }),

        onSuccess: () => {
            showSuccess(t('success'), 'login-help-question-success');
        },

        onError: (error: Error) => {
            showError(t(`errors.${ error.message }`), 'login-help-question-error');
        }
    });
}
